/* eslint-disable */
import $ from 'jquery';
import _ from 'underscore';
import backbone from 'backbone';
import ko from 'knockout';
import template from '@bingads-webui-static-legacy/bulk-edit/template/shared/changeBiddingStrategy.pug';
import changeBiddingStrategyViewModel from '@bingads-webui-static-legacy/bulk-edit/viewmodel/shared/changeBiddingStrategy';
import BaseView from '@bingads-webui-static-legacy/bulk-edit/view/bulkEditJob';
import * as _settingView from '@bingads-webui-campaign-legacy/bidding-strategy/view/setting';
import biddingStrategyType from '@bingads-webui-campaign-legacy/bidding-strategy/bidding-strategy-type';
import filterHelper from '@bingads-webui-static-legacy/bulk-edit/view/filterHelper';
import * as safeJSON from '@bingads-webui/safe-json';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var settingView = _settingView.default;
var allowedEntities = ['Campaign', 'AdGroup', 'Keyword'];
var parseType = function (value) {
  if (!_.isString(value)) {
    return '';
  }
  var typeReg = /.*"Type":([0-9]+).*$/;
  var matches = value.match(typeReg);
  if (matches && matches[1] && _.contains(_.keys(biddingStrategyType.biddingStrategyType), matches[1])) {
    return i18n.getString('BidStrategy_' + matches[1]);
  } else {
    return '';
  }
};
var formatTypes = function (rows, entityType) {
  if (!rows) {
    return rows;
  }
  _.each(rows, function (value) {
    value.Entity = _.find(value.EntityKey, function (item) {
      var keyName = '';
      switch (entityType) {
        case 'Campaign':
          keyName = 'CampaignName';
          break;
        case 'AdGroup':
          keyName = 'AdgroupName';
          break;
        case 'Keyword':
          keyName = 'Keyword';
          break;
      }
      return item.Key === keyName;
    });
    value.data = [];
    value.data.push({
      value: value.Entity && value.Entity.Value ? value.Entity.Value : '',
      isHtml: false
    });
    if (value.Changes && value.Changes.length) {
      if (value.Changes[0].Property === 'CampaignBidStrategyId') {
        var originalValue = safeJSON.parseSync(value.Changes[0].OriginalValue) || ({});
        var newValue = safeJSON.parseSync(value.Changes[0].NewValue) || ({});
        if (originalValue.Id) {
          value.data.push({
            value: originalValue.Name,
            isHtml: false
          });
          value.data.push({
            value: newValue.Name,
            isHtml: false
          });
        } else {
          var originalIBS = _.result(_.find(value.EntityKey, {
            Key: 'BiddingScheme'
          }), 'Value');
          value.data.push({
            value: parseType(originalIBS),
            isHtml: false
          });
          value.data.push({
            value: newValue.Name,
            isHtml: false
          });
        }
      } else {
        var originalPBS = safeJSON.parseSync(_.result(_.find(value.EntityKey, {
          Key: 'BidStrategyId'
        }), 'Value')) || ({});
        if (originalPBS.Id) {
          value.data.push({
            value: originalPBS.Name,
            isHtml: false
          });
          value.data.push({
            value: parseType(value.Changes[0].NewValue),
            isHtml: false
          });
        } else {
          value.data.push({
            value: parseType(value.Changes[0].OriginalValue),
            isHtml: false
          });
          value.data.push({
            value: parseType(value.Changes[0].NewValue),
            isHtml: false
          });
        }
      }
    } else {
      value.data.push({
        value: '',
        isHtml: false
      });
      value.data.push({
        value: '',
        isHtml: false
      });
    }
  });
  return rows;
};
var view = BaseView.extend({
  initialize: function (options) {
    this.options = options || ({});
    BaseView.prototype.initialize.apply(this, arguments);
    this.template = template;
    this.entityType = options.entityType;
    this.biddingStrategyType = options.biddingStrategyType;
    this.settingView = new settingView({
      entityType: this.entityType,
      biddingStrategyType: this.biddingStrategyType,
      isBulkEdit: true,
      i18nNewDesign: this.options.i18nNewDesign,
      campaignType: options.campaignType,
      campaignSubType: options.campaignSubType,
      getCampaignTypeGlobalFilter: options.getCampaignTypeGlobalFilter
    });
    this.ko_model = new changeBiddingStrategyViewModel(this.model, this.settingView);
  },
  render: function () {
    BaseView.prototype.render.apply(this, arguments);
    this.$('.section-container.form-horizontal').empty().html(this.settingView.render().el);
    return this;
  },
  setAction: function () {
    this.model.set('BatchAction', this.settingView.action());
    this.model.set('Entity', this.entityType);
  },
  formatPreviewResults: function (results) {
    return formatTypes(results, this.entityType);
  },
  formatErrors: function (rows) {
    if (rows) {
      _.each(rows, function (value) {
        value.Entity = _.find(value.EntityKey, function (item) {
          return item.Key === 'CampaignName';
        });
        value.data = [];
        value.data.push({
          value: value.Entity && value.Entity.Value ? value.Entity.Value : '',
          isHtml: false
        });
      });
    }
    return rows;
  },
  getIdFilter: function () {
    var result = null;
    var entity = this.model.get('Entity');
    if (_.contains(allowedEntities, entity)) {
      result = filterHelper.getIdFilter(this.grid, entity);
    }
    return result;
  }
});
export default view;

